import Styles from './ReelOrShortLoadingPreview.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const ReelOrShortLoadingPreview = () => {
  return (
    <div className={Styles.reelOrShortLoadingPreview}>
      <div className={Styles.body}></div>
      <div className={Styles.footer}>
        <div className={Styles.row}>
          <Skeleton avatar={{ size: 34 }} active title={false} paragraph={{ rows: 1 }} />
          <div className={Styles.second}>
            <Skeleton avatar={false} active title={false} paragraph={{ rows: 1 }} />
          </div>
        </div>
        <Skeleton avatar={false} active title={false} paragraph={{ rows: 2 }} />
        <div className={Styles.loader} />
        <div className={Styles.loaderFull} />
      </div>
    </div>
  )
}
